import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, isDevMode} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {JwtModule} from '@auth0/angular-jwt';
// import {DevExtremeModule} from 'devextreme-angular';
import {AppRoutingModule} from './app-routing.module';
import {authInterceptor} from './core/http/auth.interceptor';
import {AppComponent} from './app.component';
import {PulseMainModule} from './main/main.module';
import {PulseModule} from '@pulse/pulse.module';
import {PulseSharedModule} from '@pulse/shared.module';
import {PulseHeaderModule} from 'app/main/header/header.module';
import {PulseFooterModule} from 'app/main/footer/footer.module';
import {PulseContentModule} from 'app/main/content/content.module';
import {UsersService} from './services/users/users.service';
import {siteConfig} from './siteSettings';
import {CoreModule} from './core/core.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers, metaReducers } from './store';
import * as authEffects from './store/auth/auth.effects';
import * as uiEffects from './store/ui/ui.effects';
import * as commonEffects from './store/common/common.effects';

export function tokenGetter() {
    return localStorage.getItem('userToken');
}
@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                authScheme: 'JWT ',
                allowedDomains: [siteConfig.baseApiHost],
                disallowedRoutes: [`${siteConfig.nodeAPIBaseUrl}login`, `${siteConfig.nodeAPIV3BaseUrl}login`]
            }
        }),
        TranslateModule.forRoot(),
        PulseModule,
        // DevExtremeModule,
        PulseSharedModule,
        PulseMainModule,
        PulseHeaderModule,
        PulseContentModule,
        PulseFooterModule,
        AppRoutingModule,
        CoreModule,
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
            }
        }),
        EffectsModule.forRoot({ ...authEffects, ...uiEffects, ...commonEffects }),
        StoreRouterConnectingModule.forRoot(),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: !isDevMode(),
            autoPause: true,
        }),
    ], providers: [
        UsersService,
        provideHttpClient(withInterceptors([authInterceptor])),
    ] })
export class AppModule {
}
